import { render, staticRenderFns } from "./SurplusReturnTotals.vue?vue&type=template&id=734826da&scoped=true"
import script from "./SurplusReturnTotals.vue?vue&type=script&lang=js"
export * from "./SurplusReturnTotals.vue?vue&type=script&lang=js"
import style0 from "./SurplusReturnTotals.vue?vue&type=style&index=0&id=734826da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734826da",
  null
  
)

export default component.exports